import { classNames } from "./classNames";

type StatusBadgeProps = {
  status: string;
  className?: string;
};

const toneByStatus: Record<string, string> = {
  active: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  ready: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  verified: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  payment_pending: "bg-amber-50 text-amber-700 ring-amber-200",
  needs_packet_review: "bg-amber-50 text-amber-700 ring-amber-200",
  needs_review: "bg-amber-50 text-amber-700 ring-amber-200",
  blocked: "bg-red-50 text-red-700 ring-red-200",
  disputed: "bg-red-50 text-red-700 ring-red-200",
};

export function formatStatus(status: string) {
  const label = status.replace(/_/g, " ");
  return label.charAt(0).toUpperCase() + label.slice(1);
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  return <span className={classNames("inline-flex rounded-full px-2.5 py-1 text-xs font-semibold uppercase tracking-wide ring-1", toneByStatus[status] ?? "bg-slate-100 text-slate-700 ring-slate-200", className)}>{formatStatus(status)}</span>;
}
